import { render } from "./HomeWork.vue?vue&type=template&id=d9f127a0"
import script from "./HomeWork.vue?vue&type=script&lang=js"
export * from "./HomeWork.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__